import { Button, Typography } from "@mui/material";
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";

import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import serviceFaturaInstalacao from "../../../../services/serviceFaturaInstalacao";
import { toast } from "react-toastify";
import { useState } from "react";

export interface IDialogProps {
  open: boolean;
  onClose?: any;
  onSave?: any;
  statusSelecionado?: any;
  qtdeFatura?: any;
  faturaIds?: any;
}

export default function DialogAlterStatusAll({
  open,
  onClose,
  onSave,
  statusSelecionado,
  qtdeFatura,
  faturaIds,
}: IDialogProps) {
  const [isDisable, setDisable] = useState(false);
  const novoStatus =
    statusSelecionado[0].value === "Aprovando" ? "Aberta" : "Publicada";
  const [motivo, setMotivo] = useState("");
  const [motivoError, setMotivoError] = useState(false);

  const handleRequest = async () => {
    if (motivo.trim() === "") {
      setMotivoError(true);
      toast.warning("Por favor, preencha o motivo.");
      return;
    }

    setDisable(true);

    const payload = {
      FaturasIds: faturaIds.join(","),
      novoStatus: novoStatus,
      motivo: motivo,
    };

    try {
      const result = await serviceFaturaInstalacao.alterStatus(payload);
      if (result) {
        toast.success("Status das Faturas Alterados com sucesso!");
        onSave();
        onClose();
      }
    } catch (error) {
      toast.error("Erro ao alterar status das faturas.");
    } finally {
      setDisable(false);
    }
  };

  const publishMessage = {
    multiple: `Tem certeza de que deseja alterar o status das ${qtdeFatura} faturas selecionadas para ${novoStatus}?`,
    simple: `Tem certeza de que deseja alterar o status desta fatura para ${novoStatus}?`,
  };

  return (
    <div>
      <Dialog
        maxWidth="md"
        fullWidth
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            onClose();
          }
        }}
        open={open}
      >
        <DialogTitle>
          Alterar status da fatura
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Typography variant="subtitle1" alignItems="center">
            {qtdeFatura > 1 ? publishMessage.multiple : publishMessage.simple}
          </Typography>

          <Grid container spacing={2} alignItems="center" justifyContent="center" mt={2}>
            {/* Status atual */}
            <Grid item xs={12} md={4}>
              <TextField
                label="Atual"
                defaultValue={statusSelecionado[0]?.value || ""}
                variant="filled"
                fullWidth
                InputProps={{ readOnly: true }}
              />
            </Grid>

            <Grid item xs={12} md={1} display="flex" justifyContent="center">
              <ArrowForwardOutlinedIcon style={{ fontSize: 40, color: "#5B5B5F" }} />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                label="Novo"
                defaultValue={novoStatus}
                variant="filled"
                fullWidth
                InputProps={{ readOnly: true }}
              />
            </Grid>

            <Grid item xs={12} md={9} mt={2}>
              <TextField
                name="motivo"
                label="Descreva o Motivo"
                multiline
                rows={3}
                inputProps={{ maxLength: 150 }}
                fullWidth
                variant="outlined"
                required
                value={motivo}
                onChange={(e) => {
                  setMotivo(e.target.value);
                  if (e.target.value.trim() !== "") {
                    setMotivoError(false);
                  }
                }}
                error={motivoError}
                helperText={motivoError ? "Campo obrigatório" : ""}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
          <Button
            onClick={onClose}
            color="warning"
            variant="contained"
            style={{ width: "159px", height: "44px" }}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleRequest}
            color="primary"
            variant="contained"
            disabled={isDisable}
            style={{ width: "159px", height: "44px" }}
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
